module.exports = __webpack_public_path__ + "static/media/chalkboard.457292a3.svg";